import axios from "axios";
// const Integrated_API_URL = "http://localhost:7047/";
const Integrated_API_URL = "https://omg.rainboosoftmate.com/";
// const baseURL = "https://demo.quizzzmaster.com/";
// const baseURL = "https://cali-quiz.door2future.com/";
// const baseURL="https://omg.quizmasterr.com/";
const baseURL="/";
// const baseURL="http://localhost:6084/";

export const sendOtp = async (data) => {
    try {
        const response = await axios.post(`${Integrated_API_URL}OTP/sendOTP`,{msisdn: data});
        return response.data.message;
    } catch (e) {
        throw e.response.data;
    }
};


// Zip Game Apis
export const sendOtpzip=async(msisdn)=>{
 const response = await axios.post(`${Integrated_API_URL}OTP/sendOTP`, {
        msisdn,
    });
    return response.data;
}
export const he=async()=>{
    // window.location.href=`${Integrated_API_URL}he`
//  const response = await axios.get(`${Integrated_API_URL}he`, {
//     });
//     return response.data;
}
export const varifyOtpzip=async(msisdn,otp)=>{
   const response = await axios.post(`${Integrated_API_URL}OTP/verifyOTP`, {
        msisdn,
        otp,
        pack_type:null,
        ext_ref:"zip"
    });
    return response.data;
}
export const varifyOtplogin=async(msisdn,otp)=>{
   const response = await axios.post(`${Integrated_API_URL}OTP/verifyOTP_login`, {
        msisdn,
        otp
    });
    return response.data;
}

export const registerZipUser = async (msisdn, name) => {
    const response = await axios.post(`${baseURL}api/v1/zip-game/register`, {
        msisdn, name
    });
    return response;
}

export const loginZipUser = async (msisdn) => {
    const response = await axios.post(`${baseURL}api/v1/zip-game/login`, {
        msisdn
    });
    return response;
}

export const zipPlayGame = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/play`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipSaveScore = async (token, total_time_seconds, moves, game_trx_id) => {
    const response = await axios.post(`${baseURL}api/v1/zip-game/save-score`, { total_time_seconds, moves, game_trx_id },
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    return response;
}

export const zipGameResult = async (game_trx_id, token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/user-game-result?game_trx_id=${game_trx_id}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipGameLeaderboardApi = async (date, token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/leaderboard?date=${date}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipGameWinnersApi = async (date, token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/winners?date=${date}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const checkZipUserSubscription = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/auth/checker`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipUserProfileApi = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/profile`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipUserProfileEditApi = async (formData, token) => {
    const response = await axios.post(`${baseURL}api/v1/zip-game/edit-profile`, formData, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipUserHistoryApi = async (page, token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/history?page=${page}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const login = async (data) => {
    const response = await axios.post(`${baseURL}api/v1/login`, data);
    return response;
};
export const loginhe  = async (data) => {
    const response = await axios.post(`${baseURL}api/v1/loginhe`, data);
    return response;
};

export const getFunFact = async () => {
    const response = await axios.get(`${baseURL}api/v1/fun-facts`);
    return response;
};

export const getProfile = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-user-profile`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response;
};

export const getAllQuiz = async (language, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-all-quizes?lang_id=${language}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response;
};

export const getQuiz = async (quizId, levelId, currentLanguage, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-quiz/${quizId}/${levelId}?lang_id=${currentLanguage}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    return response;
}

export const getQuizDetails = async (quizId, levelId, currentLanguage, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-quiz/${quizId}/${levelId}?lang_id=${currentLanguage}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response?.data?.result?.questionCount ?? 0;
}

export const getLeaderboard = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-leaderboard`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
};

export const updateProfile = async (formData, token) => {
    try {
        const response = await axios.post(`${baseURL}api/v1/protected/edit-profile`, formData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data.data;
    } catch (e) {
        console.log(e);
    }
};

export const getHistory = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-history?offset=0`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
};

export const startQuizSession = async (quizType, quizId, levelId, languageId, token) => {
    return axios.post(`${baseURL}api/v1/protected/quiz-sessions`, {
        quizType,
        quizId,
        levelId,
        languageId
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });
};

export const submitQuizSessionAnswer = async (sessionId, questionIndex, selectedOption, token) => {
    return axios.post(`${baseURL}api/v1/protected/quiz-sessions/answer`, {
        sessionId,
        questionIndex,
        selectedOption
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });
};

export const finishQuizSession = async (sessionId, token) => {
    return axios.post(`${baseURL}api/v1/protected/quiz-sessions/finish`, {
        sessionId
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });
};

export const getAllOpponent = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/finding-opponent`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
};

export const startGamePlay = async (gameName, levelId, token) => {
    return axios.post(`${baseURL}api/v1/protected/start-game-play`, {
        gameName,
        levelId
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });
};

export const submitWordGuess = async (attemptId, guessIndex, guess, token) => {
    return axios.post(`${baseURL}api/v1/protected/submit-word-guess`, {
        attemptId,
        guessIndex,
        guess
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });
};

export const finishWordGame = async (attemptId, token) => {
    return axios.post(`${baseURL}api/v1/protected/finish-word-game`, {
        attemptId
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });
};

export const playXoMove = async (attemptId, position, token) => {
    return axios.post(`${baseURL}api/v1/protected/play-xo-move`, {
        attemptId,
        position
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });
};

export const saveUserPoints = async (quizId, quizName, quizImage, levelId, points, totalPoints, token) => {
    void totalPoints;
    const response = await axios.post(`${baseURL}api/v1/protected/save-user-points`, {
        quizId: quizId,
        quizName: quizName,
        quizImage: quizImage,
        levelId: levelId,
        userPoints: points
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });
    return response;
};

export const getReverseQuizQuestions = async (level, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-reverse-quiz-questions?level=${level}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const saveReverseQuizPoints = async (levelId, points, totalPoints, token) => {
    void totalPoints;
    const response = await axios.post(`${baseURL}api/v1/protected/save-reverse-quiz-points`, {
        levelId: levelId,
        userPoints: points
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });

    return response;
}

export const checkUserSubscription = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/check-user-subscription`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const saveWordGamePointsApi = async (levelId, points, totalPoints, token) => {
    void totalPoints;
    const response = await axios.post(`${baseURL}api/v1/protected/save-word-game-points`, {
        levelId: levelId,
        userPoints: points
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });

    return response;
}

// const Integrated_API_URL = "https://omg.rainboosoftmate.com/";
// const Integrated_API_URL = "/";

export const subscribeApi = async (msisdn, pack, extRef) => {
    const response = await axios.post(`${Integrated_API_URL}activate-user`, {
        msisdn,
        pack_type: pack,
        ext_ref: extRef
    });

    return response;
}

export const sendOTPApi = async (msisdn) => {
    const response = await axios.post(`${Integrated_API_URL}OTP/sendOTP`, {
        msisdn,
    });

    return response;
}

export const verifyOTPApi = async (msisdn, otp,pack_type, ext_ref) => {
    const response = await axios.post(`${Integrated_API_URL}OTP/verifyOTP`, {
        msisdn,
        otp,
        pack_type,
        ext_ref
    });
    return response;
}

export const unsubscribeAPI = async (msisdn) => {
    const response = await axios.post(`${Integrated_API_URL}deactivate-user`, { msisdn,alias:localStorage.getItem('alias') });
    return response;
}